import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModalFormState {
  isModalFormOpen: boolean;
}

const initialState: ModalFormState = {
  isModalFormOpen: false,
};

const modalFormSlice = createSlice({
  name: "modalForm",
  initialState,
  reducers: {
    toggleModalForm: (state, action: PayloadAction<boolean>) => {
      state.isModalFormOpen = action.payload;
    },
  },
});

export const { toggleModalForm } = modalFormSlice.actions;
export default modalFormSlice.reducer;
